export default "__VITE_ASSET__BxYcPCAu__"